// @flow
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { getCategoryFacetLink } from '../../utils/urls';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styles from './TaxonomyFacet.module.scss';

type Props = {
    facets: any[],
    onSeeMore: Function,
    queryParams: any,
    renderAsParent: boolean,
    seeMore: boolean,
    showLandingPageLinks: boolean,
    taxonomySelected: Function,
};

export default class TaxonomyNode extends Component<Props> {
    renderSeeMore = (facets: any, seeMore: boolean) => {
        if (seeMore || (!seeMore && facets.length <= 10)) return null;
        return (
            <a onClick={this.props.onSeeMore}>
                <FormattedMessage id="search_see_more" />
            </a>
        );
    };

    renderCategoryItem = (
        categoryItem: any,
        queryParams: any,
        showLandingPageLinks: boolean,
        taxonomySelected: Function
    ) => {
        let categoryElement = null;

        if (categoryItem.selected) {
            categoryElement = <div className={styles.selected}>{categoryItem.name}</div>;
        } else if (
            !categoryItem.selected &&
            (!categoryItem.landingPageUrl || (categoryItem.landingPageUrl && !showLandingPageLinks))
        ) {
            categoryElement = (
                <a value={categoryItem.id} onClick={() => taxonomySelected(categoryItem.id)}>
                    {categoryItem.name}
                    &nbsp;
                    <span className={styles.count}>({Number(categoryItem.count).toLocaleString()})</span>
                </a>
            );
        } else if (!categoryItem.selected && categoryItem.landingPageUrl && showLandingPageLinks) {
            categoryElement = (
                <Link className={styles.link} route to={getCategoryFacetLink(categoryItem.landingPageUrl, queryParams)}>
                    {categoryItem.name}
                    &nbsp;
                    <span className={styles.count}>({Number(categoryItem.count).toLocaleString()})</span>
                </Link>
            );
        }

        return categoryElement;
    };

    render() {
        const {
            facets,
            onSeeMore,
            queryParams,
            renderAsParent,
            seeMore,
            showLandingPageLinks,
            taxonomySelected,
        } = this.props;

        const seeMoreLink = this.renderSeeMore(facets, seeMore);
        const facetsDom = facets.map((categoryItem, index) => {
            if (!seeMore && index >= 10) return null;
            const classForIndentation = renderAsParent ? styles['option-parent'] : styles.option;
            return (
                <div key={categoryItem.id} className={classForIndentation}>
                    {this.renderCategoryItem(categoryItem, queryParams, showLandingPageLinks, taxonomySelected)}
                    {!categoryItem.categories ? null : (
                        <TaxonomyNode
                            facets={categoryItem.categories}
                            queryParams={queryParams}
                            onSeeMore={onSeeMore}
                            renderAsParent={false}
                            seeMore={seeMore}
                            showLandingPageLinks={showLandingPageLinks}
                            taxonomySelected={taxonomySelected}
                        />
                    )}
                </div>
            );
        });

        return (
            <div>
                {facetsDom}
                {seeMoreLink}
            </div>
        );
    }
}
